import { Marker } from "react-leaflet"
import { GeoJsonFeature } from "../../../services/OgcService/models/GeoJsonFeature"
import { SituationProperties } from "../../../services/OgcService/models/SituationFeatureCollection"
import * as L from "leaflet";
import { GeoJsonGeometryType } from "../../../services/RuteplanAPI/models/GeoJsonGeometryType";

export interface ITrafficMessagePointMarkerProps {
    trafficMessage: GeoJsonFeature<SituationProperties>;
    icon: L.DivIcon;
    onTrafficMessageClicked: (feature: GeoJsonFeature<SituationProperties>) => void;
}

export function TrafficMessagePointMarker(trafficeMessageMarkerProps: ITrafficMessagePointMarkerProps) {
    const { trafficMessage, icon, onTrafficMessageClicked } = trafficeMessageMarkerProps;

    if (trafficMessage && trafficMessage.geometry.type === GeoJsonGeometryType.POINT) {
        const coordinates = [ trafficMessage.geometry.coordinates[1] as unknown as number, trafficMessage.geometry.coordinates[0] as unknown as number]
        return (
            <Marker
                key={trafficeMessageMarkerProps.trafficMessage.properties._id}
                eventHandlers={{ click: () => { onTrafficMessageClicked(trafficeMessageMarkerProps.trafficMessage) } }}
                icon={icon}
                position={[coordinates[0], coordinates[1]]}>
            </Marker>
        )
    }
    return null;
}